export default "__VITE_ASSET__gS9e7maA__"